import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from '../../utils/getClassNames';
import styles from './ButtonGroup.module.scss';

export type ButtonGroupProps = {
  children: React.ReactNode;
  fullWidth?: boolean;
  classNameModifier?: string;
};

const ButtonGroup: FC<ButtonGroupProps> = ({
  children,
  fullWidth = false,
  classNameModifier = '',
}) => (
  <div className={getClassNames(styles, 'root', classNames(classNameModifier, { fullWidth }))}>
    {children}
  </div>
);

export default ButtonGroup;
